import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { Button, Loading } from 'components';
import { certificatesGenerateToken } from '../.config/redux/actions';

const CertificatesView = () => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { loading } = useSelector(state => state.certificatesRedux);

    const certificates = [
        { key: 'debt', label: 'Certificado de Deuda', icon: 'fas fa-file-invoice' },
        { key: 'current', label: 'Certificado al Día', icon: 'fas fa-check-circle' },
        { key: 'peace', label: 'Paz y Salvo', icon: 'fas fa-handshake' },
        { key: 'tax', label: 'Certificado Tributario', icon: 'fas fa-receipt' }
    ];

    const handleDownload = (type) => {
        dispatch(certificatesGenerateToken(type));
    };

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Certificados</h4>
                            </div>
                            <div className="card-body">
                                <Loading loading={loading}>
                                    <div className="row">
                                        {certificates.map((cert) => (
                                            <div key={cert.key} className="col-md-6 col-lg-3 mb-3">
                                                <div className="card" style={{ height: "fit-content" }}>
                                                    <div className="card-body text-center d-flex flex-column">

                                                        {/* Icono + título */}
                                                        <div className="mb-3 d-flex flex-column align-items-center">
                                                            <i className={`${cert.icon} fs-1 text-primary mb-2`}></i>
                                                            <h6 className="mb-0">{cert.label}</h6>
                                                        </div>

                                                        {/* Botón */}
                                                        <Button
                                                            className="btn btn-primary btn-rounded btn-sm"
                                                            onClick={() => handleDownload(cert.key)}
                                                            loading={loading}
                                                            loadingText={"Descargar"}
                                                        >
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Loading>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default CertificatesView;
